<template>
  <div class="section">
    <div class="colaboradores_responsive">
      <div class="linha_separador_saber_mais"></div>
      <div class="row">
        <div class="small-10 columns">
          <p class="colab_resp_text">{{ $t("apresentacao.conhercerequipa") }}</p>
        </div>
        <div class="small-2 button saber_mais_info" :class="{ minus: showTeam }" @click="showTeamToogle">
        </div>
      </div>
      <div class="linha_separador_saber_mais"></div>
    </div>
    <div class="row plist" 
      :class="{ hide : !shouldShowTeam}" 
      v-same-height="'.pessoa'">
      <div v-for="(member, index) in equipa" 
        :key="index"
        class="small-12 medium-6 large-4 columns gridel">
          <Pessoa 
            :responsavel="member.responsavel" 
            :email="member.email" 
            :nome="member?.nome" 
            :imagem="member.imagem"
            :url="member.url" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from "vue";
import axios from "@/axios.js";
import Pessoa from "@/components/Pessoa.vue";
import { i18n } from "@/main";

export default {
  name: 'Composicao',
  components: {
    Pessoa
  },
  setup() {

    const equipa = ref([]);

    const getMembros = () => {
      axios.get(`/servico/${import.meta.env.VITE_UID}/equipa`).then(data => {
        equipa.value = data.data.filter(el => el.ID > 0).
        sort((a, b) => {
          if (a.responsavel) {
            return -1;
          }
          if (b.responsavel) {
            return 1;
          }
          return 0;
        }).
        map(el => {
          const lg = i18n.global.locale == "en" ? "en/" : "";
          return {
            ...el,
            url: `${import.meta.env.VITE_BASE_URL_SITE}/${lg}directorio/${el.url}`
          }
        });
      })
        .catch(error => {
          console.log(error);
        })
    }

    getMembros()

    const isSmallScreen = ref(window.innerWidth <= 767);

    const updateScreenWidth = () => {
      isSmallScreen.value = window.innerWidth <= 767;
    };

    onMounted(() => {
      window.addEventListener('resize', updateScreenWidth);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateScreenWidth);
    });

    const showTeam = ref(false);
    const shouldShowTeam = computed(() => !isSmallScreen.value || showTeam.value);

    const showTeamToogle = () => {
      showTeam.value = !showTeam.value;
      console.log(showTeam.value);
    }

    return {
      shouldShowTeam,
      showTeamToogle,
      showTeam,
      equipa,
    }

  }
}
</script>

<style scoped>
.colaboradores_responsive {
  display: none;
}

.section {
  padding-bottom: 80px;
  padding-top: 35px;
}

.gridel {
  margin-bottom: 12px;
  padding-left: 0px;
}

.gridel:nth-of-type(3n-1) a,
.gridel:nth-of-type(3n) a {
  padding-left: 5px;
}

.gridel:nth-of-type(3n-2) a {
  padding-left: 2px;
}

@media (min-width: 1225px) {

  .gridel:nth-of-type(3n-2),
  .gridel:nth-of-type(3n-1) {
    padding-right: 11px;
  }
}


@media (max-width: 1280px) {
  .gridel {
    padding-right: 5px;
    padding-left: 5px;
  }
}

@media (min-width : 768px) and (max-width : 1024px) {
  .gridel {
    padding-bottom: 0px;
  }
}

@media screen and (max-width:767px) {

  .section {
    padding-top: 0;
  }

  .colaboradores_responsive {
    display: block;
  }

  .gridel {
    margin-bottom: 5px;
    height: 76px;
    user-select: none;
    max-width: 100%;
    flex: 1 1 100%;
  }

  .gridel .pessoa {
    height: 76px !important;
  }

  .linha_separador_saber_mais {
    border-bottom: 1px solid #79b2dc;
  }

  .colaboradores_responsive p {
    font-family: "Montserrat Bold";
    font-size: 15px;
    color: #79b2dc;
    text-transform: uppercase;
    padding-left: 0px;
    padding-top: 19px;
  }

  .colaboradores_responsive .columns {
    padding-left: 0px;
  }

  .saber_mais_info {
    font-family: "Montserrat Semibold";
    text-transform: uppercase;
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 24px;
    padding: 12px 18px;
    width: 50.16px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    float: right;
    background-color: #79b2dc;
  }

  .saber_mais_info:after {
    position: absolute;
    content: "+";
    font-size: 28px;
    font-family: "Montserrat SemiBold";
    letter-spacing: 0.3px;
  }

  .saber_mais_info.minus:after {
    position: absolute;
    content: "-";
    font-size: 28px;
    font-family: "Montserrat SemiBold";
    letter-spacing: 0.3px;
  }

  .plist{
    padding-top: 15px;
    display: flex;
  }

  .plist.hide{
    display: none;
  }
}
</style>
